import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderMissionVision() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 1,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper mb-lg-4"
            >
                <SwiperSlide>
                    <div className="owl-item" style={{ width: 350, marginRight: 30 }}>
                        <div className="service-block">
                            <div className="service-block_inner">
                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                <span className="service-block_icon flaticon-examining-table" />
                                <h4 className="service-block_heading"><a to="intensive-care.html">24/7 Ambulance Facilities</a></h4>
                                <div className="service-block_text">Satna Swastik Hospital Provide 24/7 Ambulance Facilities Around Satna City.</div>
                                {/* <a className="service-block-more" to="intensive-care.html">Read More</a> */}
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="owl-item" style={{ width: 350, marginRight: 30 }}>
                        <div className="service-block">
                            <div className="service-block_inner">
                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                <span className="service-block_icon flaticon-dentist-chair" />
                                <h4 className="service-block_heading"><a to="intensive-care.html">Expert & Dedicated Doctors</a></h4>
                                <div className="service-block_text">Satna Swastik Hospital Have Best Super Specialist Expert & Dedicated Doctors Team.</div>
                                {/* <a className="service-block-more" to="intensive-care.html">Read More</a> */}
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item" style={{ width: 350, marginRight: 30 }}>
                        <div className="service-block">
                            <div className="service-block_inner">
                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                <span className="service-block_icon flaticon-mri" />
                                <h4 className="service-block_heading"><a to="intensive-care.html">Accidental Trauma Unit</a></h4>
                                <div className="service-block_text">Satna Swastik Hospital Have Expert & Dedicated Doctors With Best Accidental Trauma Unit.</div>
                                < br />
                                {/* <a className="service-block-more" to="intensive-care.html">Read More</a> */}
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </>
    );
}
